import script from "./AuIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AuIcon.vue?vue&type=script&setup=true&lang=js"

import "./AuIcon.vue?vue&type=style&index=0&id=5c55d1cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c55d1cd"]])

export default __exports__